import { Routing } from '../Routes';
import { useParams, match } from 'react-router-dom';
import { useApi, Res, fetchResourceMap } from '../../state/api';
import { Main } from '../Main/Main';
import { ProductTable } from '../ProductTable/ProductTable';
import { LoaderPage } from './LoaderPage';
import { ErrorPage } from './ErrorPage';
import { renderTemplate } from '../utils';
import { useTranslation } from '../../i18n/i18n';
import { ButtonLink } from '../Form/Button';
import { ContentCard } from '../ContentCard/ContentCard';
import { Helmet } from 'react-helmet-async';

type UrlParams = { brandSlug: string; modelSlug: string };

export const TonerGuidePage = (): JSX.Element => {
	const { brandSlug, modelSlug } = useParams<UrlParams>();
	const { data: printer, error } = useApi(Res.printer, {
		brandSlug,
		modelSlug,
	});
	const t = useTranslation().tonerGuide;
	const urls = useTranslation().routes;

	if (error) return <ErrorPage />;
	if (!printer) return <LoaderPage />;

	return (
		<Main>
			<Helmet>
				<title>
					{renderTemplate(t.modelTitle, {
						type:
							t.types[printer.type].productTypeName.charAt(0).toUpperCase() +
							t.types[printer.type].productTypeName.slice(1),
						brandName: printer.brand.name,
						modelName: printer.model,
					})}
				</title>
				<meta
					name="description"
					content={renderTemplate(t.modelMeta, {
						type:
							t.types[printer.type].productTypeName.charAt(0).toUpperCase() +
							t.types[printer.type].productTypeName.slice(1),
						printerType: t.types[printer.type].printerType,
						brandName: printer.brand.name,
						modelName: printer.model,
					})}
				/>
			</Helmet>
			<h1>
				{printer.brand.name} - {printer.model}
			</h1>
			<ContentCard>
				<p>
					{renderTemplate(t.tonesThatSuitPrinter, {
						type: t.types[printer.type].productTypeName,
						printerType: t.types[printer.type].printerType,
						name: printer.brand.name,
						model: printer.model,
					})}
				</p>
				<ProductTable products={printer.products} />
				<p>
					<strong>{t.tip}!</strong>
					{renderTemplate(t.searchForPrinter, {
						model: printer.model,
						types: t.types[printer.type].productTypeName,
					})}
				</p>
				<div className="text-center">
					<ButtonLink linkTo={`${urls.search}?q=${printer.model}`}>
						{renderTemplate(t.searchForPrinterNow, {
							model: printer.model,
						})}
					</ButtonLink>
				</div>
			</ContentCard>
		</Main>
	);
};

export const tonerGuideRouting: Routing<UrlParams> = {
	path(urls) {
		return `${urls.printer}/:brandSlug/:modelSlug`;
	},
	component: TonerGuidePage,
	requiresAuth: false,
	preload: async (config, routeMatch: match<UrlParams>) => {
		const { brandSlug, modelSlug } = routeMatch.params;
		return fetchResourceMap(config, Res.printer, { brandSlug, modelSlug });
	},
};
